export const schedulingTimesWrapperStyles = {
	backgroundColor: 'backgrounds.white',
	p: 0,
};

export const schedulingTimesContentWrapperStyles = {
	px: '1.25rem',
	py: { xs: '1.25rem', md: '2.5rem' },
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	textAlign: 'center',
	'> *': {
		width: '100%',
	},
};

export const schedulingTimesListStyles = {
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	justifyContent: { xs: 'center', md: 'space-between' },
	alignItems: 'center',
	gap: '0.55rem',
	my: '1.5rem',
	width: '100%',
};

export const schedulingTimesImageStyles = {
	width: '100%',
	height: '24.375rem',
	overflow: 'hidden',
};

export const schedulingMessageStyles = {
	display: { xs: 'block', md: 'inline-block' },
	lineHeight: '1.75rem',
};

export const timeMessageStyles = {
	paddingTop: '1.25rem',
	borderTop: '1px solid',
	borderColor: 'borders.lighterGray',
};
